declare global {
  interface Window {
    DD_RUM?: DatadogRum;
  }
}

interface DatadogError extends Error {
  type?: string;
}

interface DatadogRum {
  addError?: (error: Error, metadata: Record<string, string>) => void;
  setGlobalContextProperty?: (key: string, value: unknown) => void;
}

/**
 * This function generates an custom error given the type. Metadata optional
 *
 * https://docs.datadoghq.com/real_user_monitoring/browser/collecting_browser_errors/
 * @param errorType required, the type that defines the error in datadog.
 * @param message required, description of the error.
 * @param metadata optional, see above link for possible parameters
 */
export const addDatadogError = (
  errorType: string,
  message: string,
  metadata?: Record<string, string>,
) => {
  if (
    typeof window !== "undefined" &&
    window.DD_RUM &&
    typeof window.DD_RUM.addError === "function"
  ) {
    const generatedError: DatadogError = new Error(message);
    generatedError.type = errorType;

    if (!metadata) metadata = {};
    window.DD_RUM.addError(generatedError, {
      ...metadata,
      type: errorType,
    });
  }
};
